module.exports = __webpack_public_path__ + "static/media/figure3.9475d6dc.jpg";